import { AxiosResponse } from "axios";
import { useQuery } from "react-query";

import { MainUrl } from "core/data/main-url";
import { IAxiosResult } from "../../models/axios-result.model";
import methods from "../interceptors/http.interceptor";

const url = `${MainUrl}/api/store/location/Location`;

const GetAllProvinces = async (): Promise<AxiosResponse<IAxiosResult>> => {
  return await methods.get(`${url}/GetAllProvinces`);
};

const GetAllCountiesByProvinceId = async (
  id: number,
): Promise<AxiosResponse<IAxiosResult>> => {
  return await methods.get(
    `${url}/GetAllCountiesByProvinceId?provinceId=${id}`,
  );
};

const GetAllRuralsByCountyId = async (
  id: number,
): Promise<AxiosResponse<IAxiosResult>> => {
  return await methods.get(`${url}/GetAllRuralsByCountyId?countyId=${id}`);
};

const GetAllCitiesByCountyId = async (
  id: number,
): Promise<AxiosResponse<IAxiosResult>> => {
  return await methods.get(`${url}/GetAllCitiesByCountyId?countyId=${id}`);
};

const GetAllVillagesByCountyId = async (
  id: number,
): Promise<AxiosResponse<IAxiosResult>> => {
  return await methods.get(`${url}/GetAllVillagesByCountyId?countyId=${id}`);
};

//-----------------------------------------------------------------------------------------------------------

export const useGetAllProvinces = () =>
  useQuery("GetAllProvinces", GetAllProvinces, {
    staleTime: 2 * 60 * 1000,
    cacheTime: 2 * 60 * 1000,
  });

export const useGetAllCountiesByProvinceId = (id: number) =>
  useQuery(
    ["GetAllCountiesByProvinceId", id],
    () => GetAllCountiesByProvinceId(id),
    {
      enabled: !!id,
    },
  );

export const useGetAllRuralsByCountyId = (id: number) =>
  useQuery(["GetAllRuralsByCountyId", id], () => GetAllRuralsByCountyId(id), {
    enabled: !!id,
  });

export const useGetAllCitiesByCountyId = (id: number) =>
  useQuery(["GetAllCitiesByCountyId", id], () => GetAllCitiesByCountyId(id), {
    enabled: !!id,
  });

export const useGetAllVillagesByCountyId = (id: number) =>
  useQuery(
    ["GetAllVillagesByCountyId", id],
    () => GetAllVillagesByCountyId(id),
    {
      enabled: !!id,
    },
  );
